import React, { useRef } from "react";
import { useDrag } from "react-dnd";
import { ROW } from "./constants";
import DropZone from "./DndDropZone";
import Column from "./DndColumn";

const style = {};
const Row = ({ data, components, handleDrop, path, useFullWidth, handleItemDataUpdate, handleItemSizeUpdate }) => {
  const ref = useRef(null);

  const [{ isDragging }, drag] = useDrag({
    type: ROW,
    item: {
      id: data.id,
      children: data.children,
      path
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });

  const opacity = isDragging ? 0 : 1;
  drag(ref);
  

  const renderColumn = (row, column, currentPath) => {
    return (
      <Column
        key={column.id}
        data={column}
        row={row}
        components={components}
        handleDrop={handleDrop}
        path={currentPath}
        handleItemDataUpdate={handleItemDataUpdate}
        handleItemSizeUpdate={handleItemSizeUpdate}
      />
    );
  };

  return (
    <div ref={ref} style={{ ...style, opacity }} className={`dnd-base draggable ${useFullWidth?'dnd-row-full-width':'dnd-row'}`}>
      {/* {data.id} */}
      <div className="dnd-columns">
        {data.children.map((column, index) => {
          const currentPath = `${path}-${index}`;

          return (
            <React.Fragment key={column.id}>
              <DropZone
                data={{
                  path: currentPath,
                  childrenCount: data.children.length,
                }}
                onDrop={handleDrop}
                className="horizontalDrag"
              />
              {renderColumn(data, column, currentPath)}
            </React.Fragment>
          );
        })}
        <DropZone
          data={{
            path: `${path}-${data.children.length}`,
            childrenCount: data.children.length
          }}
          onDrop={handleDrop}
          className="horizontalDrag"
          isLast
        />
      </div>
    </div>
  );
};
export default Row;
